import {config} from '@/utils'

export default {
    name: 'Console',
    created() {
        this.getData()
        this.get_application_status()
    }, 
    computed:{
        fontstyle(){
            return (status_text) => {
                if (status_text === "已过期" ){
                    return { 'color': 'red'}
                }else if (status_text === "生效中"){
                    return { 'color': '#52C41A '}
                }else if (status_text === "已用完"){
                    return { 'color': ' #414b60'}
                
                }
            }

        }
       
    },
    

    methods: {
        //获取订阅状态
        get_application_status(){
            let param={
                application_number:15
            }
            this.$api.launch_contract.get_application_status(param).then(res=>{
                if(res.status_code == 0){
                    this.charge=res.obj
                    localStorage.setItem('application_status',this.charge.application_status)
                    if(this.charge.data_retain_notice_message !='' && this.charge.application_status ==2){
                        this.bola=true
                        return
                    }
                    if(localStorage.getItem('alert') ==null  && this.charge.application_status !=3  && this.charge.application_status !=2){
                        this.bole=true
                        return
                    }
                   
                }else if(res.status_code == 99998) {
                    this.bole=false
                    this.bola=false
                }else {
                    this.$Message.error({
                       content: res.status_msg,
                       duration: 2
                   })

               }
                
            })





        },
        contact(){
            window.location.href="tencent://Message/?Uin=3167439559&amp;websiteName=q-zone.qq.com&amp;Menu=yes"

        },
        colse(){
            localStorage.setItem('alert',1)

        },
        // 获取数据
        getData() {
            this.$api.user.home().then(res=>{
                let obj = res.obj;
                this.snum=res.obj
                if(res.status_code == 0){
                    if(this.userType==2){
                        this.countItemsCom[0].number = obj.signing_total ;
                        this.countItemsCom[1].number = obj.complete_total ;
                        this.countItemsCom[2].number = obj.un_store_evidence_total;

    
                    }
                    else{
                        this.countItems[0].number = obj.owner_unsign_total;
                        this.countItems[1].number = obj.other_unsign_total;
                        this.countItems[2].number = obj.complete_total;
                        this.countItems[3].number = obj.un_store_evidence_total;
                    }
                    this.package_total = obj.package_total;

                }
                
            })
        },

        toContratc(row){
            console.log(row)
            if(row.title =="待我签署"){
                this.$router.push({
                    path:'/files/acctuserfile',
                   
                   
                })
                localStorage.setItem('fileDate',"1")

            }else if(row.title =="待他人签署"){
                this.$router.push({
                    path:'/files/acctuserfile',
                   
                })
                localStorage.setItem('fileDate',"2")


            }else if(row.title =="已完成"){
                this.$router.push({
                    path:'/files/acctuserfile',
                   
                })
                localStorage.setItem('fileDate',"4")


            }else if(row.title =="未存证"){
                this.$router.push({
                    path:'/files/acctuserfile',
                   
                })
                localStorage.setItem('fileDate',"5")

            }
            
            
        },

        //订阅
        toBuy() {
            // this.$router.push('/launch_contract/setmeal_list')
            let tempwindow=window.open('_blank');
            tempwindow.location=this.config.domain+'/console/goods/center'+'?token='+_global.token+'&num=2';
        },
        toBuys(){
            this.$router.push('/launch_contract/setmeal')
            localStorage.setItem('setmeal_list',0)
        },
        //查看订阅详情
        setmeal(){
            this.basic=true;
            this.getOldpackage()
            let param={
                page:1,
                page_number:5,
                application_number:15

            }
            this.getList(param)
        },
        getList(param){
            this.$api.launch_contract.get_order_list(param).then(res=>{
                if(res.status_code !=0){
                    this.$Message.error({
                        content: res.status_msg,
                        duration: 2
                    })

                }else{
                    this.data1=res.obj
                    res.list.forEach(et => {
                        if(et.status ==1){
                            et.status_text="生效中"
                        }
                        et.items.forEach(at => {
                            if (at.quota_type ==0) {
                                at.total_text=at.total
                                at.usage_text=at.usage
                                at.remain_text=at.remain
                            }
                            
                        });
                    });
                    this.itemsData=res.list
                    

                }
                
            })

        },
        //分页
        changeTablePage(page){
            let param={
                page:page,
                page_number:5,
                application_number:15
            }
            this.getList(param)

        },
        //判断是否为旧套餐用户
        getOldpackage(){
            this.$api.launch_contract.is_old_package_user().then(res=>{
                if(res.status_code !=0){
                    this.$Message.error({
                        content: res.status_msg,
                        duration: 2
                    })

                }else{
                    this.oldpackageuser=res.obj
                    

                }
                
            })

        },
        //历史数据
        history(){
            this.$router.push('/launch_contract/setmeal')
            localStorage.setItem('setmeal_list',1)


        },
        handleToThousands(num) {
            var result = [ ], counter = 0;
            num = (num || 0).toString().split('');
            for (var i = num.length - 1; i >= 0; i--) {
                counter++;
                result.unshift(num[i]);
                if (!(counter % 3) && i != 0) { result.unshift(','); }
            }
            return result.join('');
        },
        goto(){
            if(this.userType ==1){
                this.$router.push({
                    path:'/acctuser',
                })
            }else if(this.userType ==2){
              
                    this.$router.push({
                        path:'/acctuser/firm/approve',
                    })
    
            }
        }
    },

    data () {
        return {
            publicPath: process.env.BASE_URL,
            config,
            bole:false,
            bola:false,
            time:'',
            loading: false,
            userType:Number(localStorage.getItem('usertype')),     //用户类型：1-个人，2-企业，3-员工
            cert_status:Number(localStorage.getItem('cert_status')),     //用户类型：1-个人，2-企业，3-员工
            package_total: 0,
            items: [],
            snum:{},
            charge:[],
            countItems: [
                {
                    title: '待我签署',
                    number: '0'
                },
                {
                    title: '待他人签署',
                    number: '0'
                },
                {
                    title: '已完成',
                    number: '0'
                },
                {
                    title: '未存证',
                    number: '0'
                },
            ],
            countItemsCom:[
                {
                    title: '签署中',
                    number: '0'
                },
                {
                    title: '已完成',
                    number: '0'
                },
                {
                    title: '未存证',
                    number: '0'
                }
            ],
            basic:false,
            columns1: [
               
                {
                    title: '应用名称',
                    align:'center',
                    key: 'application_name'
                },
                {
                    title: '使用周期',
                    width:240,
                    align:'center',
                    key: 'date_range_text'
                },
                {
                    title: '总可用量',
                    align:'center',
                    key: 'total_text'
                },
                {
                    title: '已使用',
                    align:'center',
                    key: 'usage_text'
                },
                {
                    title: '剩余用量',
                    align:'center',
                    key: 'remain_text'
                }
            ],
            data1: {},
            itemsData:[],
            oldpackageuser:0,//旧套餐用户
        }
    }
}
